import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { db } from '../../firebase/firebase-config';
import { ProgressBar } from '../shared/ProgressBar';
import { nameInArroba, getLadaPorZona } from '../../helpers/util';
import Swal from 'sweetalert2';

const FormColaboradora = ({ colaboradora, onChange, onGuardar, onCancelar, horarioNegocio, ladaPais, accessToken, hashtag, esPrimera, zonaHoraria, hayDuena, yaConectoCalendario }) => {

    const handleTel = (val) => {
        onChange({ ...colaboradora, telefono: val.replace(/\D/g, '').slice(0, 10) });
    };

    const toggleDia = (idx) => {
        const nuevos = colaboradora.jornada.map((d, i) =>
            i === idx ? { ...d, activo: !d.activo } : d
        );
        onChange({ ...colaboradora, jornada: nuevos });
    };

    const aplicarATodos = (entrada, salida) => {
        const nuevos = colaboradora.jornada.map(d => 
            d.activo ? { ...d, entrada, salida } : d
        );
        onChange({ ...colaboradora, jornada: nuevos });
    };

    const aplicarComidaATodos = (ini_comida, fin_comida) => {
        const nuevos = colaboradora.jornada.map(d =>
            d.activo ? { ...d, tieneComida: true, ini_comida, fin_comida } : d
        );
        onChange({ ...colaboradora, jornada: nuevos });
    };

    const updateJornada = (idx, campo, valor) => {
        const nuevos = colaboradora.jornada.map((d, i) =>
            i === idx ? { ...d, [campo]: valor } : d
        );
        onChange({ ...colaboradora, jornada: nuevos });
    };

    const SERVICE_ACCOUNT = 'revi-calendar-bot@revi-recepcionista-virtual.iam.gserviceaccount.com';
    const CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
    const SCOPE = 'https://www.googleapis.com/auth/calendar openid email profile';

    const abrirOAuthPopup = async (callback) => {
        if (!yaConectoCalendario) {
            const { isConfirmed } = await Swal.fire({
                title: 'Importante: marca el permiso ✅',
                html: 'En la siguiente pantalla de Google, asegúrate de <b>marcar ✅ el checkbox</b> que aparece para autorizar el acceso al calendario.<br/><br/>Sin ese permiso, <b>no podremos agendar las citas correctamente</b>.',
                imageUrl: '/img/explicar_calendar.png',
                imageAlt: 'Marcar checkbox de permisos de Google Calendar',
                imageWidth: 280,
                confirmButtonText: 'Entendido, continuar',
                confirmButtonColor: '#D4537E',
                showCancelButton: true,
                cancelButtonText: 'Cancelar',
            });
            if (!isConfirmed) return;
        }

        const redirectUri = window.location.origin + '/app';
        const url = `https://accounts.google.com/o/oauth2/v2/auth?` +
            `client_id=${CLIENT_ID}` +
            `&redirect_uri=${encodeURIComponent(redirectUri)}` +
            `&response_type=token` +
            `&scope=${encodeURIComponent(SCOPE)}` +
            `&prompt=select_account`;

        const popup = window.open(url, 'google-oauth', 'width=500,height=600,left=200,top=100');
        const poll = setInterval(() => {
            try {
                if (!popup || popup.closed) { clearInterval(poll); return; }
                const hash = popup.location.hash;
                if (hash && hash.includes('access_token')) {
                    const params = new URLSearchParams(hash.substring(1));
                    const token = params.get('access_token');
                    if (token) {
                        clearInterval(poll);
                        popup.close();
                        callback(token);
                    }
                }
            } catch (e) {}
        }, 500);
    };

    const conectarCalendarioPersonal = () => {
        if (!colaboradora.nombre.trim()) {
            Swal.fire('Falta el nombre', 'Ingresa primero el nombre de la colaboradora.', 'warning');
            return;
        }
        abrirOAuthPopup(async (token) => {
            try {
                const userInfo = await fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
                    headers: { Authorization: `Bearer ${token}` }
                }).then(r => r.json());

                await fetch('https://www.googleapis.com/calendar/v3/calendars/primary/acl', {
                    method: 'POST',
                    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
                    body: JSON.stringify({ role: 'writer', scope: { type: 'user', value: SERVICE_ACCOUNT } })
                });

                // Actualizar zona horaria del calendario personal
                // Actualizar zona horaria del calendario personal
                const tzResponse = await fetch(`https://www.googleapis.com/calendar/v3/calendars/${encodeURIComponent(userInfo.email)}`, {
                    method: 'PATCH',
                    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
                    body: JSON.stringify({ timeZone: zonaHoraria || 'America/Mexico_City' })
                });

                const tzResult = await tzResponse.json();
                console.log('Timezone update response:', tzResult);

                onChange({ ...colaboradora, idCalendar: userInfo.email, esDuena: true });
                Swal.fire('¡Listo!', `Calendario de ${userInfo.email} conectado correctamente.`, 'success');
            } catch (e) {
                Swal.fire('Error', 'No se pudo conectar el calendario. Intenta de nuevo.', 'error');
            }
        });
    };

    const crearCalendarioSecundario = () => {
        if (!colaboradora.nombre.trim()) {
            Swal.fire('Falta el nombre', 'Ingresa primero el nombre de la colaboradora.', 'warning');
            return;
        }
        abrirOAuthPopup(async (token) => {
            try {
                const nombre = colaboradora.nombre.trim();
                const calCreado = await fetch('https://www.googleapis.com/calendar/v3/calendars', {
                    method: 'POST',
                    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
                    body: JSON.stringify({ summary: `Revi - ${nombre}`, timeZone: zonaHoraria || 'America/Mexico_City' }),
                }).then(r => r.json());

                if (!calCreado.id) throw new Error('No se pudo crear el calendario');

                await fetch(`https://www.googleapis.com/calendar/v3/calendars/${encodeURIComponent(calCreado.id)}/acl`, {
                    method: 'POST',
                    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
                    body: JSON.stringify({ role: 'writer', scope: { type: 'user', value: SERVICE_ACCOUNT } }),
                });

                onChange({ ...colaboradora, idCalendar: calCreado.id, esDuena: false });
                Swal.fire('¡Listo!', `Calendario "Revi - ${nombre}" creado y conectado correctamente.`, 'success');
            } catch (e) {
                Swal.fire('Error', 'No se pudo crear el calendario. Intenta de nuevo.', 'error');
            }
        });
    };

    const bandera = ladaPais === '521' ? '🇲🇽' : ladaPais === '57' ? '🇨🇴' : '🌎';

    return (
        <div style={{ background: 'var(--pink-50)', border: '0.5px solid var(--border)', borderRadius: 12, padding: 16, marginTop: 8 }}>
            <div className="field-label" style={{ marginTop: 0 }}>Nombre</div>
            <input
                className="field-input"
                placeholder="Ej. Andrea"
                value={colaboradora.nombre}
                onChange={e => onChange({ ...colaboradora, nombre: e.target.value })}
                autoFocus
            />
            <p className="field-hint">Así la verán tus clientas al reservar</p>

            <div className="field-label">Teléfono de WhatsApp</div>
            <div style={{ display: 'flex', gap: 8 }}>
                <div style={{ padding: '12px', border: '0.5px solid var(--border)', borderRadius: 10, fontSize: 14, color: 'var(--pink-900)', whiteSpace: 'nowrap', background: '#fff' }}>
                    {bandera} +{ladaPais}
                </div>
                <input
                    className="field-input"
                    style={{ flex: 1 }}
                    placeholder="10 dígitos"
                    type="tel"
                    inputMode="numeric"
                    value={colaboradora.telefono}
                    onChange={e => handleTel(e.target.value)}
                    maxLength={10}
                />
            </div>
            <p className="field-hint">📲 Aquí le llegarán las notificaciones de nuevas citas</p>

            <div className="field-label">Calendario de Google</div>
            {colaboradora.idCalendar ? (
                <div className="info-box" style={{ marginTop: 0 }}>
                    <div className="info-box-title">✓ Calendario conectado {colaboradora.esDuena && '👑'}</div>
                    <div className="info-box-body" style={{ wordBreak: 'break-all' }}>{colaboradora.idCalendar}</div>
                </div>
            ) : (
                <>
                    <p className="field-hint" style={{ marginBottom: 8 }}>📅 Aquí se verán reflejadas las citas en Google Calendar</p>
                    {hayDuena ? (
                        <>
                            <button
                                className="btn-primary"
                                style={{ fontSize: 13, marginTop: 0, width: '100%' }}
                                onClick={crearCalendarioSecundario}
                            >
                                📅 Crear calendario para esta colaboradora
                            </button>
                            <p className="field-hint" style={{ marginTop: 8, fontSize: 11, lineHeight: 1.4 }}>
                                💡 Se creará un calendario nuevo dentro de tu cuenta de Google (la dueña). Desde ahí podrás ver las citas de esta colaboradora.
                            </p>
                        </>
                    ) : (
                        <>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginTop: 0 }}>
                                <button
                                    className="btn-primary"
                                    style={{ fontSize: 12, marginTop: 0 }}
                                    onClick={conectarCalendarioPersonal}
                                >
                                    👑 Es para mí
                                </button>
                                <button
                                    className="btn-outline"
                                    style={{ fontSize: 12, marginTop: 0 }}
                                    onClick={crearCalendarioSecundario}
                                >
                                    Es para una colaboradora
                                </button>
                            </div>
                            <p className="field-hint" style={{ marginTop: 8, fontSize: 11, lineHeight: 1.4 }}>
                                💡 <b>Es para mí:</b> conecta tu calendario personal de Google.<br/>
                                <b>Es para una colaboradora:</b> se crea un calendario nuevo dentro de tu cuenta de Google. Desde ahí podrás ver las citas de esa colaboradora.
                            </p>
                        </>
                    )}
                </>
            )}

            <div className="field-label" style={{ marginTop: 16 }}>Horario</div>
            <p className="field-hint" style={{ marginBottom: 8 }}>
                {esPrimera
                    ? 'Configura los días y horarios en que atiendes'
                    : 'Basado en el horario de la primera colaboradora. Ajusta si es necesario.'}
            </p>

            {colaboradora.jornada.map((dia, idx) => (
                <div key={dia.id} className="day-row" style={{ flexDirection: 'column', alignItems: 'flex-start', gap: 8 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, width: '100%' }}>
                        <div className="day-name">{dia.label}</div>
                        <div className={`day-toggle ${dia.activo ? 'on' : ''}`} onClick={() => toggleDia(idx)}>
                            <div className="day-toggle-thumb" />
                        </div>
                        {dia.activo ? (
                            <div style={{ display: 'flex', alignItems: 'center', gap: 6, flex: 1, flexWrap: 'wrap' }}>
                                <input className="time-input" type="time" value={dia.entrada} onChange={e => updateJornada(idx, 'entrada', e.target.value)} />
                                <span style={{ fontSize: 12, color: 'var(--pink-800)' }}>a</span>
                                <input className="time-input" type="time" value={dia.salida} onChange={e => updateJornada(idx, 'salida', e.target.value)} />
                                <button
                                    onClick={() => aplicarATodos(dia.entrada, dia.salida)}
                                    style={{ fontSize: 10, color: 'var(--pink-600)', background: 'none', border: '0.5px solid var(--pink-200)', borderRadius: 6, padding: '2px 6px', cursor: 'pointer', whiteSpace: 'nowrap' }}
                                >
                                    Aplicar a todos
                                </button>
                            </div>
                        ) : (
                            <span style={{ fontSize: 12, color: 'var(--pink-200)' }}>No trabaja</span>
                        )}
                    </div>
                    {dia.activo && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8, paddingLeft: 8 }}>
                            <div
                                className={`day-toggle ${dia.tieneComida ? 'on' : ''}`}
                                style={{ width: 28, height: 16, borderRadius: 8 }}
                                onClick={() => updateJornada(idx, 'tieneComida', !dia.tieneComida)}
                            >
                                <div className="day-toggle-thumb" style={{ width: 12, height: 12, top: 2, left: dia.tieneComida ? 14 : 2 }} />
                            </div>
                            <span style={{ fontSize: 12, color: 'var(--pink-800)' }}>Hora de comida</span>
                            {dia.tieneComida && (
                                <div style={{ display: 'flex', alignItems: 'center', gap: 4, flexWrap: 'wrap' }}>
                                    <input className="time-input" type="time" value={dia.ini_comida} onChange={e => updateJornada(idx, 'ini_comida', e.target.value)} />
                                    <span style={{ fontSize: 11, color: 'var(--pink-800)' }}>a</span>
                                    <input className="time-input" type="time" value={dia.fin_comida} onChange={e => updateJornada(idx, 'fin_comida', e.target.value)} />
                                    <button
                                        onClick={() => aplicarComidaATodos(dia.ini_comida, dia.fin_comida)}
                                        style={{ fontSize: 10, color: 'var(--pink-600)', background: 'none', border: '0.5px solid var(--pink-200)', borderRadius: 6, padding: '2px 6px', cursor: 'pointer', whiteSpace: 'nowrap' }}
                                    >
                                        Aplicar a todos
                                    </button>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            ))}

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginTop: 16 }}>
                <button className="btn-outline" onClick={onCancelar}>Cancelar</button>
                <button className="btn-primary" style={{ marginTop: 0 }} onClick={onGuardar}>Guardar</button>
            </div>
        </div>
    );
};

const DIAS_DEFAULT = [
    { id: 'lunes', label: 'Lunes', activo: true, entrada: '10:00', salida: '20:00', tieneComida: false, ini_comida: '13:00', fin_comida: '14:00' },
    { id: 'martes', label: 'Martes', activo: true, entrada: '10:00', salida: '20:00', tieneComida: false, ini_comida: '13:00', fin_comida: '14:00' },
    { id: 'miercoles', label: 'Miércoles', activo: true, entrada: '10:00', salida: '20:00', tieneComida: false, ini_comida: '13:00', fin_comida: '14:00' },
    { id: 'jueves', label: 'Jueves', activo: true, entrada: '10:00', salida: '20:00', tieneComida: false, ini_comida: '13:00', fin_comida: '14:00' },
    { id: 'viernes', label: 'Viernes', activo: true, entrada: '10:00', salida: '20:00', tieneComida: false, ini_comida: '13:00', fin_comida: '14:00' },
    { id: 'sabado', label: 'Sábado', activo: true, entrada: '10:00', salida: '18:00', tieneComida: false, ini_comida: '13:00', fin_comida: '14:00' },
    { id: 'domingo', label: 'Domingo', activo: false, entrada: '10:00', salida: '18:00', tieneComida: false, ini_comida: '13:00', fin_comida: '14:00' },
];

const DIAS_LABELS = { lunes: 'Lunes', martes: 'Martes', miercoles: 'Miércoles', jueves: 'Jueves', viernes: 'Viernes', sabado: 'Sábado', domingo: 'Domingo' };

const jornadaADias = (jornada) => {
    const diasActivos = jornada.map(d => d.id);
    return DIAS_DEFAULT.map(d => ({
        ...d,
        activo: diasActivos.includes(d.id),
        ...(jornada.find(j => j.id === d.id) || {}),
        label: DIAS_LABELS[d.id] || d.id,
        tieneComida: jornada.find(j => j.id === d.id)?.ini_comida !== '00:00' && jornada.find(j => j.id === d.id)?.ini_comida !== undefined,
    }));
};

const colaboradoraVacia = (horarioBase) => ({
    nombre: '',
    telefono: '',
    idCalendar: '',
    esDuena: false,
    jornada: horarioBase ? jornadaADias(horarioBase) : [...DIAS_DEFAULT],
});

export const PasoQuienAtiende = ({ siguiente, anterior, horarioNegocio }) => {
    const { hashtag, ladaPais, accessToken, zonaHoraria } = useSelector(state => state.auth);
    const lada = ladaPais || '521';
    const [colaboradoras, setColaboradoras] = useState([]);
    const [agregando, setAgregando] = useState(false);
    const [horarioBase, setHorarioBase] = useState(horarioNegocio || null);
    const [colActual, setColActual] = useState(null);
    const [cargando, setCargando] = useState(false);

    const [cargandoCols, setCargandoCols] = useState(true);

    // Cargar colaboradoras existentes Y horario base
    useEffect(() => {
        const cargar = async () => {
            try {
                const snap = await db.collection(`general/${hashtag}/consultores`).get();
                if (!snap.empty) {
                    const cols = snap.docs.map(doc => ({
                        id: doc.id,
                        nombre: doc.id.replace('@', ''),
                        telefono: doc.data().telefono?.slice(-10) || '',
                        idCalendar: doc.data().idCalendar || '',
                        esDuena: doc.data().esDuena === true,
                        jornada: jornadaADias(doc.data().jornada || []),
                        guardado: true,
                    }));
                    setColaboradoras(cols);
                    // Usar jornada del primero como base
                    if (!horarioBase && snap.docs[0].data().jornada) {
                        setHorarioBase(snap.docs[0].data().jornada);
                    }
                }
            } catch (e) {
                console.log('Error cargando colaboradoras:', e);
            } finally {
                setCargandoCols(false);
            }
        };
        cargar();
    }, [hashtag]);

    const abrirFormNuevo = () => {
        setColActual(colaboradoraVacia(horarioBase));
        setAgregando(true);
    };

    const handleGuardar = () => {
        if (!colActual.nombre.trim()) {
            Swal.fire('Falta el nombre', 'Escribe el nombre de la colaboradora.', 'warning');
            return;
        }
        if (colActual.telefono.length !== 10) {
            Swal.fire('Teléfono inválido', 'El teléfono debe tener 10 dígitos.', 'warning');
            return;
        }
        if (!colActual.idCalendar) {
            Swal.fire('Falta el calendario', 'Conecta o crea un calendario de Google para esta colaboradora.', 'warning');
            return;
        }
        setColaboradoras([...colaboradoras, { ...colActual }]);
        setColActual(colaboradoraVacia(horarioNegocio));
        setAgregando(false);
    };

    const handleContinuar = async () => {
        if (colaboradoras.length === 0) {
            Swal.fire('Sin colaboradoras', 'Agrega al menos una persona que atienda en tu negocio (puede ser tú misma).', 'warning');
            return;
        }
        setCargando(true);
        try {
            for (const col of colaboradoras) {
                const id = nameInArroba(col.nombre);
                const diasActivos = col.jornada.filter(d => d.activo);
                const jornada = diasActivos.map(d => ({
                    id: d.id,
                    entrada: d.entrada,
                    salida: d.salida,
                    ini_comida: d.tieneComida ? d.ini_comida : '00:00',
                    fin_comida: d.tieneComida ? d.fin_comida : '00:00',
                }));
                await db.doc(`general/${hashtag}/consultores/${id}`).set({
                    activo: true,
                    telefono: lada + col.telefono,
                    idCalendar: col.idCalendar,
                    esDuena: col.esDuena === true,
                    jornada,
                    noJornadas: jornada.length,
                    noServicios: 0,
                });
            }
            siguiente();
        } catch (e) {
            Swal.fire('Error', 'No se pudo guardar. Intenta de nuevo.', 'error');
        } finally {
            setCargando(false);
        }
    };

    return (
        <div className="app-container">
            <div className="app-header">
                <h1>¿Quién atiende?</h1>
                <p>Casi terminamos 🎉</p>
            </div>
            <ProgressBar paso={5} />

            <div className="screen-body">
                <div className="info-box" style={{ marginTop: 0 }}>
                    <div className="info-box-body">
                        Agrega a cada persona que atiende en tu negocio, incluyéndote a ti misma si tú también das servicio.
                    </div>
                </div>

                {colaboradoras.map((col, idx) => (
                    <div key={idx} className="item-card">
                        <div style={{ width: 40, height: 40, borderRadius: '50%', background: 'var(--pink-100)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, fontWeight: 600, color: 'var(--pink-900)', flexShrink: 0 }}>
                            {col.nombre.charAt(0).toUpperCase()}
                        </div>
                        <div style={{ flex: 1 }}>
                            <div className="item-name">{col.nombre} {col.esDuena && <span title="Dueña">👑</span>}</div>
                            <div className="item-meta">
                                {col.idCalendar ? '✓ Calendario conectado' : 'Sin calendario'} · {col.jornada.filter(d => d.activo).length} días
                            </div>
                        </div>
                        <button onClick={() => setColaboradoras(colaboradoras.filter((_, i) => i !== idx))}
                            style={{ color: '#c62828', background: 'none', border: 'none', fontSize: 18, cursor: 'pointer' }}>×</button>
                    </div>
                ))}

                {agregando ? (
                    <FormColaboradora
                        colaboradora={colActual}
                        onChange={setColActual}
                        onGuardar={handleGuardar}
                        onCancelar={() => { setAgregando(false); setColActual(colaboradoraVacia(horarioBase)); }}
                        horarioNegocio={horarioBase}
                        ladaPais={lada}
                        accessToken={accessToken}
                        hashtag={hashtag}
                        esPrimera={colaboradoras.length === 0}
                        zonaHoraria={zonaHoraria}
                        hayDuena={colaboradoras.some(c => c.esDuena === true)}
                        yaConectoCalendario={colaboradoras.some(c => c.idCalendar)}
                    />
                ) : (
                    <button className="add-btn" onClick={abrirFormNuevo}>
                        + Agregar colaboradora
                    </button>
                )}
            </div>

            <div className="screen-footer">
                <button className="btn-primary" onClick={handleContinuar} disabled={cargando}>
                    {cargando ? 'Guardando...' : 'Finalizar configuración'}
                </button>
                <button className="btn-secondary" onClick={anterior}>Volver</button>
            </div>
        </div>
    );
};
